module.exports = __webpack_public_path__ + "static/hovalin-strings-2-acb1de381545d038544aaa8606971b3e.jpg";